<template>
  <div>
    <div class="row justify-content-start">
      <div class="col-auto d-flex align-items-center">
        <h3>Products</h3>
      </div>
    </div>
    <hr>
    <div class="row justify-content-between align-middle">
      <div class="col-auto">
        <div class="input-group mb-3">
          <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
      
            <span v-if="!search_params_changed">
              <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
            
              <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
            </span>
            <span v-else>
              <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
            </span> &nbsp &nbsp <a class="btn btn-outline-danger btn-reset" style="border-radius: 0.375rem;" type="button" role="button" :href="'/products'">Reset</a>
             
        </div>

      </div>
      <div class="col-auto">
        <ul class="nav justify-content-end">
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Type</span>
                <select v-model="pagination.searchparams.type" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="">All</option>
                  <option v-for="category in pagination.product_filters.category">
                    {{ category }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Style</span>
                <select v-model="pagination.searchparams.style" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="">All</option>
                  <option v-for="style in pagination.product_filters.style">
                    {{ style }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Model</span>
                <select v-model="pagination.searchparams.model" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="">All</option>
                  <option v-for="model in pagination.product_filters.model">
                    {{ model }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Size</span>
                <select v-model="pagination.searchparams.size" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="">All</option>
                  <option v-for="size in pagination.product_filters.size" :value="size">
                    {{ size | sizeDisplay }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item pl-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Color</span>
                <select v-model="pagination.searchparams.color" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="">All</option>
                  <option v-for="color in pagination.product_filters.color">
                    {{ color }}
                  </option>
                </select>
              </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-4 pt-2">
        <p class="float-left">Showing <strong>{{ pagination.from | commanumeric }}</strong>-
          <strong>{{ pagination.to | commanumeric }}</strong>
          of <strong>{{ pagination.total | commanumeric }}</strong>
        </p>
      </div>
      <div v-if="pagination.data.length > 0" class="col-md-4 pb-2">
        <nav aria-label="Page navigation">
          <ul class="pagination nav justify-content-center">
            <li class="page-item" ><a class="page-link" @click="firstPage"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>
            <li class="page-item" :class="{ disabled: pagination.current_page == 1 }"><a class="page-link" @click="prevPage" >Previous</a></li>
            <li class="page-item" :class="{ disabled: !pagination.has_more_pages }"><a class="page-link" @click="nextPage">Next</a></li>
            <li class="page-item"><a class="page-link" @click="lastPage"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>
          </ul>
        </nav>
      </div>
      <div class="col-md-4">
        <ul class="nav justify-content-end">
          <!-- <li>
            <div class="input-group">
                <span class="input-group-text">Type</span>
                <select v-model="pagination.searchparams.type" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option value="Apparel">Apparel</option>
                  <option value="Bag">Bag</option>
                  <option value="Board">Board</option>
                  <option value="Bundle">Bundle</option>
                  <option value="Fins">Fins</option>
                  <option value="Rope">Rope</option>
                </select>
              </div>
          </li> -->
          <li class="nav-item px-1 pt-1">
            
              <div class="form-check">
                <input v-model="pagination.searchparams.in_stock_only" class="form-check-input" type="checkbox" true-value="true" false-value="" id="flexCheckIndeterminate" @change="search_params_changed = true" :disabled="loading">
                <label class="form-check-label" for="flexCheckIndeterminate">
                  In Stock Only
                </label>
              </div>
           
          </li>
          <li class="nav-item pl-1">
          
              <div class="input-group input-group-sm">
                <span class="input-group-text">Page Size</span>
                <select v-model="pagination.per_page" class="form-select" style="background-color:#fff" id="inputGroupSelect01" @change="search_params_changed = true" :disabled="loading">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            
          </li>
        </ul>
      </div>
    </div>
    <div  class="row justify-content-center">
      <div class="col-md-12">
        <div class="card" v-if="pagination.data.length > 0">      
          <table class="table table-hover align-middle" style="display:table">
            <thead class="thead-light">
              <tr>
                <th scope="col" style="white-space:nowrap;" class="text-center"></th>
                <th scope="col" style="white-space:nowrap;">SKU</th>
                <th scope="col" style="white-space:nowrap;">Description</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Available</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Pending</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Incoming</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Volume Discount Price</th>
                <!-- <th scope="col" style="white-space:nowrap;">Wholesale</th> -->
                <th scope="col" style="white-space:nowrap;" class="text-center">US Retail MAP</th>
              </tr> 
            </thead>
            <tbody>
              <tr v-for="product in products"style="height:60px;">
                <td class="text-center"><img style="max-height:75px;" :src="product.image_url" crossorigin="anonymous" /></td>
                <td class="">{{ product.sku }}</td>
                <td class="">{{ product.name }}</td>
                <td class="text-center">{{ product.quantity_available }}</td>
                <td class="text-center">{{ product.quantity_pending }}</td>
                <td class="text-center">{{ product.quantity_incoming }}</td>
                <td class="text-center">{{ product.sale_price | currency }}</td>
                <td class="text-center">{{ product.retail_price | currency }}</td>
              </tr>
            </tbody>

          </table>
          <div class="row justify-content-center">
              <div v-if="pagination.data.length > 0" class="col-md-12 pt-0 pb-3">
                <nav aria-label="Page navigation">
                  <ul class="pagination nav justify-content-center">
                    <li class="page-item" ><a class="page-link" @click="firstPage"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>
                    <li class="page-item" :class="{ disabled: pagination.current_page == 1 }"><a class="page-link" @click="prevPage" >Previous</a></li>
                    <li class="page-item" :class="{ disabled: !pagination.has_more_pages }"><a class="page-link" @click="nextPage">Next</a></li>
                    <li class="page-item"><a class="page-link" @click="lastPage"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>
                  </ul>
                </nav>
              </div>
            </div>

        </div>
        <div v-else class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              No products matching search criteria found
            </div>
          </div>
        </div>
              <!-- <div class="card" v-for="product in products">

                  <div class="card-body row">
                      <div class="col-md-2">
                        <img style="max-height:100px;" :src="product.image_url" crossorigin="anonymous" />
                      </div>
                      <div class="col-md-5">
                        <h2>{{ product.name }}</h2>
                        <h3>$ {{ product.sale_price }}</h3>
                      </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.btn-search {
    border-radius: 0rem .25rem .25rem 0rem;
  }

  .btn-reset {
    border-top-left-radius: 0.375rem;
  }

</style>

<script>
// import 'qs';
const qs = require('qs');
// import qs from 'qs';

import moment from 'moment'
  export default {
   props:[],
    data() {
      return {
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 25,
          "product_filters": {
            "category": [],
            "style": [],
            "model": [],
            "size": [],
            "color": [],
          },
          "searchparams": {
            "search": "",
            "sortby": "sku",
            "order": "asc",
            "type": "",
            "style": "",
            "model": "",
            "color": "",
            "size": "",
            "in_stock_only": ""
          },
        },
        data_endpoint: "/api/products",
        search_params_changed: false,
        products: [],
        loading: false,
        fetched_products: false,
      };
    },
    created() {
      // runs when the component is created
        console.log('fuck');
      this.fetchData();
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {

    },
    methods: {
      fetchData(){
        this.fetchProducts(this.pagination.searchparams);
      },

      fetchProducts(params, page = 1) {
        this.loading = true;
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.data_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.products = res.data.data;
            this.product_filters = res.data.product_filters;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_products = true;
            this.loading = false;
            return true;
          });
      },
      nextPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchProducts(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchProducts(this.pagination.searchparams);
        this.search_params_changed = false;
      },
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MM/DD/YYYY, h:mm a');
        }
    }
  }

</script>
